import styled from 'styled-components';

export const Container = styled.div`
  div:last-child {
    margin-bottom: 0 !important;
  }

  span {
    border: 2px solid ${(props) => props.theme.$primary_green};
    border-radius: 50px;
    font-size: 14px;
    color: ${(props) => props.theme.$gray_introducao};
    font-style: normal;
    font-weight: 400;

    &.check-success {
      background-color: ${(props) => props.theme.$primary_green};
    }
  }

  span i {
    color: #fff;
    font-weight: bold;
    font-size: 12px;
  }
`;
